var map = {
	"./item-1(1920).jpg": "64ac",
	"./item-1(1920)new.jpg": "cff1",
	"./item-2(1920).jpg": "46a8",
	"./item-2(1920)new.jpg": "49f9",
	"./item-3(1920).jpg": "b174",
	"./item-3(1920)new.jpg": "24fa",
	"./item-4(1920).jpg": "ca7f",
	"./item-4(1920)new.jpg": "6dd1",
	"./item-5(1920).jpg": "2f40",
	"./item-5(1920)new.jpg": "9138",
	"./item-6(1920).jpg": "156e",
	"./item-6(1920)new.jpg": "7770",
	"./item-7(1920).jpg": "d5eb",
	"./item-7(1920)new.jpg": "d3e2",
	"./item-8(1920).jpg": "ecf2",
	"./item-8(1920)new.jpg": "97fb",
	"./item-9(1920).jpg": "5a49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6cff";